import type { MaterialDataBlock, SceneObject } from "../modeling/types.ts";

/**
 * Remove materials that have no slot users and are not pinned via `fakeUser`.
 *
 * Scans every material slot on every scene object to build a used-ID set, then
 * deletes any material whose ID is absent from that set and whose `fakeUser`
 * flag is not set.
 *
 * Returns a new map when at least one material was pruned, or `null` when
 * nothing changed (so callers can skip the `set()` spread cheaply).
 */
export function pruneUnusedMaterials(
  materials: Map<string, MaterialDataBlock>,
  sceneObjects: Map<string, SceneObject>,
): Map<string, MaterialDataBlock> | null {
  const used = new Set<string>();
  for (const obj of sceneObjects.values()) {
    for (const slot of obj.materialSlots) {
      used.add(slot.materialId);
    }
  }

  let changed = false;
  const next = new Map(materials);
  for (const [id, block] of next) {
    if (!used.has(id) && !block.fakeUser) {
      next.delete(id);
      changed = true;
    }
  }

  return changed ? next : null;
}
